export default function ($translate) {
    return {
        KEYS: {
            EMPLOYEE_JOINING: 'EMPLOYEE_JOINING',
            INACTIVITY_PERIOD_ASSIGNED: 'INACTIVITY_PERIOD_ASSIGNED',
            COURSE_PASSING: 'COURSE_PASSING'
        },
        LABELS: {
            EMPLOYEE_JOINING: $translate.instant('tasklist.condition.Employee joining'),
            INACTIVITY_PERIOD_ASSIGNED: $translate.instant('tasklist.condition.Inactivity period assigned to employee'),
            COURSE_PASSING: $translate.instant('tasklist.condition.Course passing')
        }
    };
}



// WEBPACK FOOTER //
// ./src/app/enums/tasklist/condition/index.js